var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduationHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4224_12423"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "graduation-hat-alt-2",
    width: 60,
    height: 60,
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4224_12423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M44.86 30.57L55 25L30 11.25L5 25L5 40M15 43.75C15 46.51 21.71 48.75 30 48.75C38.28 48.75 45 46.51 45 43.75L45 31.25C45 31.02 44.95 30.79 44.86 30.57C44.83 30.49 44.79 30.42 44.75 30.34C43.48 28.01 37.35 26.25 30 26.25C22.64 26.25 16.51 28.01 15.24 30.34C15.2 30.42 15.16 30.49 15.13 30.57C15.04 30.79 15 31.02 15 31.25L15 43.75ZM15 43.75C15 40.98 21.71 38.75 30 38.75C38.28 38.75 45 40.98 45 43.75M5 25L15.13 30.57",
    stroke: "#718EBF",
    strokeOpacity: 1,
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationHat);
export default __webpack_public_path__ + "static/media/graduation-hat.e50a7e10eb922c9181d2bf4e17f9da78.svg";
export { ForwardRef as ReactComponent };